import { colors } from '@/constants';
import Loading from '@/components/loading/Loading';
import styled from 'styled-components';

interface FullscreenLoadingProps {
  title: string;
  subtitle: string;
}

const LoadingContainer = styled.div`
  flex: 1;
  height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  background-color: ${colors.gray.gray0};
`;

const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  max-width: 360px;
  padding: 0 20px;
  text-align: center;
`;

const LoadingTitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: ${colors.brand.grafite};
`;

const LoadingSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.gray.gray50};
`;

const FullscreenLoading = ({ title, subtitle }: FullscreenLoadingProps) => {
  return (
    <LoadingContainer>
      <LoadingContent role="status" aria-live="polite">
        <Loading scale={2} />
        <LoadingTitle>{title}</LoadingTitle>
        <LoadingSubtitle>{subtitle}</LoadingSubtitle>
      </LoadingContent>
    </LoadingContainer>
  );
};

export default FullscreenLoading;
